import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_nextPage, fn_prevPage} from "../../../function/FnBodyOrder";

@observer
class OrderPagingBottomView extends Component {
    render() {

        const { rootStore } = this.props;
        const orderStore = rootStore.orderStore;


        return (
            <div className="paging">
                <button type="button" className="prev" disabled={orderStore.getPagingInfo.page_no === 1 ? "disabled" : ""}
                    onClick={(evnet)=>fn_prevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{orderStore.getPagingInfo.page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {orderStore.getPagingInfo.max_page}
                </p>
                <button type="button" className="next" disabled={orderStore.getPagingInfo.page_no === orderStore.getPagingInfo.max_page ? "disabled" : ""}
                        onClick={(evnet)=>fn_nextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default OrderPagingBottomView;